





































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgSubscriptionsCreate extends Vue {
  public $refs!: {
    form: any,
  };

  @Prop({type: Object, default: null}) private userId!: any;
  @Action('admin/subscriptions/create') private createSubscription!: any;
  @Action('admin/subscriptions/read') private readSubscriptions!: any;
  @Getter('common/rules/all') private rules!: any;
  @Getter('admin/animals/all') private animals!: any;

  private subscription: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;

  private menu1: boolean = false;

  @Watch('dialog')
  private onDialogChanged(val: boolean) {
    if (val) {
      this.subscription = {
        deleted: false,
        entry_date: new Date().toISOString().substr(0, 10),
        var_sym: 0,
        status: 50,
      };
    }
  }

  private async create() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      const success = await this.createSubscription({
        ...this.subscription,
        userSub: this.userId,
        entry_date: this.subscription.entry_date + ' 00:00:00',
      });

      if (success) {
        this.$emit('done');
        this.dialog = false;
        this.subscription = null;
        this.$refs.form.resetValidation();
      }

      this.loading = false;
    }
  }

}
